import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { t } from "@/lib/i18n";

const I18nContext = createContext(null);

export function I18nProvider({ children, initialLang }) {
  const [lang, setLangState] = useState(
    () => initialLang || localStorage.getItem("dnp.lang") || "en",
  );

  useEffect(() => {
    localStorage.setItem("dnp.lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const tt = useCallback((path, ...args) => t(path, lang, ...args), [lang]);

  const value = useMemo(() => ({ lang, setLang: setLangState, t: tt }), [lang, tt]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
